import React, { Component } from 'react'
import { Menu, Icon } from 'antd'
import SideNav, {
  Toggle,
  Nav,
  NavItem,
  NavIcon,
  NavText
} from '@trendmicro/react-sidenav'
import history from '../history'
import Auth from '../auth/Auth'

class SideMenu extends Component {
  constructor(props, context) {
    super(props, context)
    this.handleOnSelect = this.handleOnSelect.bind(this)
  }

  logout() {
    Auth.logout()
  }

  handleOnSelect(eventKey) {
    switch (eventKey) {
      case 'home':
        history.push('/home')
        break
      case 'profile':
        history.push('/profile')
        break
      case 'signout':
        this.logout()
        history.push('/home')
        break
      default:
        break
    }
  }

  render() {
    return (
      <SideNav onSelect={eventKey => this.handleOnSelect(eventKey)}>
        <SideNav.Toggle />
        <SideNav.Nav defaultSelected="home">
          <NavItem eventKey="home">
            <NavIcon>
              <Icon type="home" />
            </NavIcon>
            <NavText>Home</NavText>
          </NavItem>
          <NavItem eventKey="profile">
            <NavIcon>
              <Icon type="home" />
            </NavIcon>
            <NavText>Home</NavText>
          </NavItem>
          <NavItem eventKey="signout">
            <NavIcon>
              <Icon type="logout" />
            </NavIcon>
            <NavText>Sign Out</NavText>
          </NavItem>
        </SideNav.Nav>
      </SideNav>
    )
  }
}
export default SideMenu



// WEBPACK FOOTER //
// ./src/containers/SideMenu.js